import { onCLS, onINP, onLCP, type Metric } from "web-vitals";
import { trackEvent } from "./analytics";

// Real Core Web Vitals, sent through the existing consent-gated trackEvent
// pipeline (see analytics.ts) — inert by construction until both cookie
// consent and a real GA4 measurement ID exist, same as every other event
// in this codebase. Values are rounded per Google's own recommended
// reporting convention (ms for LCP/INP, CLS*1000 for whole-number
// precision) so they arrive as clean integers in GA4's event params.
function report(metric: Metric) {
  trackEvent("web_vitals", {
    metric_name: metric.name,
    value: metric.name === "CLS" ? Math.round(metric.value * 1000) : Math.round(metric.value),
    rating: metric.rating,
  });
}

export function initWebVitals() {
  onLCP(report);
  onCLS(report);
  onINP(report);
}
